// CloudDocDropdown.jsx
import React from 'react';
import './dropDown.scss';

const CloudDocDropdown = ({ isOpen, onClose, sub_categoryList, history ,modalpolicyChange,modalpolicyCountrychange,countriesList,movetoContact}) => {
   if (!isOpen) return null;


   return (
      <div className="policy-modal-backdrop" onClick={onClose} >
         <div className="policy-modal-content" onClick={(e) => e.stopPropagation()} onMouseLeave={onClose}>
            <div className="dropdown-grid">
               <div className="dropdown-menu-custom">
                  <div className="dropdown-grid">
                     <div className="dropdown-column">
                        <h3>Service Type</h3>
                        {sub_categoryList &&
                           sub_categoryList?.map((item) => (
                              <div className="menu-item" key={item._id} onClick={() => modalpolicyChange(item.slug)}>
                                 <h4>{item?.name === 'Home Care' ? 'Domiciliary Care' : item.name}</h4>
                                 <p>{item?.slug === 'home-care' ? "Policies for personal care at home" : item?.slug === 'children-s-home' ? "Ofsted-compliant policy sets" : item?.slug === "supported-living" ? "Adult support services": item?.slug === 'supported-accommodation-for-young-people' ? "Unregulated 16+ provision": item?.slug === 'care-home' ? 'CQC-ready care home policies': item?.slug === 'temporary-staffing' ? 'Care worker agency policies':  '-'}</p>
                              </div>
                           ))}
                        {/* <div className="menu-item">
                           <h4>Domiciliary Care</h4>
                           <p>Policies for personal care at home</p>
                        </div>
                        <div className="menu-item">
                           <h4>Children's Home</h4>
                           <p>Ofsted-compliant policy sets</p>
                        </div>
                        <div className="menu-item">
                           <h4>Supported Living</h4>
                           <p>Adult support services</p>
                        </div>
                        <div className="menu-item">
                           <h4>Supported Accommodation (16-18)</h4>
                           <p>Unregulated 16+ provision</p>
                        </div>
                        <div className="menu-item">
                           <h4>Care Home</h4>
                           <p>CQC-ready care home policies</p>
                        </div>
                        <div className="menu-item">
                           <h4>Temporary Staffing</h4>
                           <p>Care worker agency policies</p>
                        </div> */}
                     </div>

                     <div className="dropdown-column">
                        <h3>Policy Bundles by Regulator</h3>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('england')}>
                           <h4>CQC (England)</h4>
                           <p>Application & Policy Suite</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('england')}>
                           <h4>Ofsted (England)</h4>
                           <p>Children & Supported Packs</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('wales')}>
                           <h4>CIW (Wales)</h4>
                           <p>Domiciliary & Residential</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('scotland')}>
                           <h4>Care Inspectorate (Scotland)</h4>
                           <p>Adult/Children’s Policies</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('northern-ireland')}>
                           <h4>RQIA (N. Ireland)</h4>
                           <p>Compliance Packs</p>
                        </div>
                     </div>

                     <div className="dropdown-column">
                        <h3>By Country</h3>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('england')}>
                           <h4>England</h4>
                           <p>CQC/Ofsted policies</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('wales')}>
                           <h4>Wales</h4>
                           <p>CIW-compliant docs</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('scotland')}>
                           <h4>Scotland</h4>
                           <p>Care Inspectorate aligned</p>
                        </div>
                        <div className="menu-item" onClick={() => modalpolicyCountrychange('northern-ireland')}>
                           <h4>N. Ireland</h4>
                           <p>RQIA standards</p>
                        </div>

                        <div className="subscription-section">
                           <h3>Subscription Options</h3>
                           <div className="menu-item">
                              <h4>Monthly Access</h4>
                              <p>Regular updates</p>
                           </div>
                           <div className="menu-item">
                              <h4>Annual Plan</h4>
                              <p>Priority support</p>
                           </div>
                        </div>
                     </div>

                     <div className="dropdown-column" onClick={()=> movetoContact()}>
                        <h3>Get Help</h3>
                        <div className="menu-item">
                           <h4>Short Help Form</h4>
                           <p>Request follow-up</p>
                        </div>
                        <div className="menu-item">
                           <h4>Live Chat</h4>
                           <p>Instant support</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default CloudDocDropdown;
